import { Stack, Text } from "@mantine/core";

const PrintFooter = () => (
  <Stack align="center" gap={3}>
    {/* eslint-disable-next-line @next/next/no-img-element */}
    <img
      alt="event check in qr code"
      src="https://scoreboarder.net/assets/images/widelogo-dark.png"
      height={11}
      width={126}
    />
    <Text size="xs" color="dimmed" ta="center">
      powered by scoreboarder.net
    </Text>
  </Stack>
);
export default PrintFooter;
